import { render, staticRenderFns } from "./OnlineRateInfoForm.vue?vue&type=template&id=70f3e01c&"
import script from "./OnlineRateInfoForm.vue?vue&type=script&lang=js&"
export * from "./OnlineRateInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports